import { combineReducers } from "redux";
import Assignment from "routes/Home/Attendance/Salary/Assignment/Module";
import RulePack from "routes/Home/Attendance/Salary/RulePack/Module";
import Report from "routes/Home/Attendance/Salary/Report/Module";
import AdditionsAndSubtractions from "routes/Home/Attendance/Salary/Post/Module";
import SalaryItems from "routes/Home/Salary/SalaryItems/Module";
import WritsSalary from "routes/Home/Attendance/Salary/WritsSalary/Module";
import SalaryFish from "routes/Home/Attendance/Salary/SalaryFish/Module";
import FactorSalary from "routes/Home/Salary/FactorSalary/Module";
import Modifier from "routes/Home/Attendance/Salary/Modifier/Module";

const reducers = combineReducers({
  Assignment,
  RulePack,
  Report,
  AdditionsAndSubtractions,
  SalaryItems,
  WritsSalary,
  SalaryFish,
  FactorSalary,
  Modifier,
});

export default reducers;
